const search = {
    setHandlers() {
        $("#slt-sortBy").on("change", function () {
            const url = new URL(window.location.href);
            const params = url.searchParams;
            params.set("sort_by", this.value);
            url.search = params.toString();
            window.location.href = url.toString();
        });
    },
    setSortLabels() {
        const sort_by = document.getElementById("slt-sortBy");
        if (!sort_by) {
            return;
        }
        const sort_labels = {
            "most-relevant": "Relevant",
            "price-ascending": "Price ↑",
            "price-descending": "Price ↓",
        };
        const original_labels = new Map(
            Array.from(sort_by.options, option => [option.value, option.textContent.trim()])
        );
        const mobile_query = window.matchMedia("(max-width: 767.98px)");
        function updateSortLabels(event) {
            Array.from(sort_by.options).forEach(option => {
                option.textContent = event.matches
                    ? sort_labels[option.value] ?? original_labels.get(option.value)
                    : original_labels.get(option.value);
            });
        }
        mobile_query.addEventListener("change", updateSortLabels);
        updateSortLabels(mobile_query);
    },
    start() {
        this.setHandlers();
        this.setSortLabels();
    },
};
$(function () {
    search.start();
});